export default __webpack_public_path__ + "static/media/LeftArrow_3.bf2520f7.svg";